"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const BookmarkOutline = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M5.5 21.385c0-.608-.862-1.098-1.375-.804l7.129-4.087.746-.427.746.427 7.129 4.087c-.514-.295-1.375.2-1.375.804V2.997c0 .278.226.503.5.503H5c.274 0 .5-.226.5-.503v18.388zM5 2h14c.552 0 1 .445 1 .997v18.388c0 .55-.386.775-.871.497L12 17.796l-7.129 4.086c-.48.276-.871.055-.871-.497V2.997C4 2.447 4.445 2 5 2z", children: " " })
] });
var BookmarkOutline_default = BookmarkOutline;
export {
  BookmarkOutline_default as default
};
